<template>
    <div class="home">
        <h1>Welcome to GameMaster.AI</h1>
    </div>
</template>

<script>export default {
        name: 'HomePath',
    };</script>

<style scoped>
</style>
